import { getMonthFromDate } from "../../../extensions/date";

const MONTH_NAMES = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export function getMonthStr(date: string): string {
  const parts = date.split("-");
  if (parts.length === 3) {
    const idx = parseInt(parts[1], 10) - 1;
    if (idx >= 0 && idx < 12) {
      return `${MONTH_NAMES[idx]}-${parts[0].slice(-2)}`;
    }
  }
  return getMonthFromDate(date);
}

export function buildDayIndexByDate(dates: string[]): Map<string, string> {
  const uniqueDates = Array.from(new Set(dates)).sort((a, b) =>
    a.localeCompare(b),
  );
  return new Map(uniqueDates.map((d, i) => [d, `Day ${i + 1}`]));
}

export function parseDateRangeValue(value: string) {
  const [startDate, endDate] = value.split(",").map((part) => part.trim());
  return { startDate, endDate };
}
